// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_28UJj2njYMt7c0olg2wBQI","reward":"_36uoEu05e454I3L9wGv_Ry","img":"_3BXsKmwEKQM0y1IfmVDsZ1","lock":"prLRTvoWhR9We_5r1FNAW","content":"yZ5Ni3oQku1dZTnAuYplR"};